import React from 'react';

const FundOwnershipContext = React.createContext({});

export default FundOwnershipContext;
